namespace B2B.UI {
    export interface IPricePopupOptions{
        title?: string,
        dsc?: string,
        btn?: string,
        theme?: string,
        category?: string,
        noEmail?: boolean,
        goalId: string,
        additionalData?: Object
    }
    export type PopupResultString = "ok" | "cancel";
    export interface IPopupResult{
        action?: PopupResultString;
        data?: any;
    }
    export class PricePopup extends B2B.UI.Popup{
        private _options: IPricePopupOptions;
        private _resolve: (data: IPopupResult) => any;

        constructor(options: IPricePopupOptions) {
            super();
            this._options = options;
            this.element.classList.add("b-popup-price");
        }

        private setup(form: HTMLElement){

            let $form = $(form);
            if(this._options.noEmail){
                $form.find("label.email").hide();
            }

            $form.find('.js-title').html(this._options.title || "Оптовый каталог");
            $form.find('.js-desc').html(this._options.dsc || '');

            let $btn = $form.find('.btn');
            $btn.html(this._options.btn || 'Получить консультацию!');

            $form.find("input").val("");
            if ($form.find(".hidden").length == 0) {
                $form.append('<div class="hidden"></div>');
            }
            $form.find('.hidden').html("");
            $form.find('.hidden').append('<input type="hidden" name="theme" value="' + this._options.theme + '">');
            if (this._options.category) {
                $form.find('.hidden').append('<input type="hidden" name="category" value="' + this._options.category + '">');
            }

            $form.removeAttr("data-goalid");
            if (this._options.goalId) {
                $form.attr("data-goalid", this._options.goalId);
            }

            $btn.get(0).addEventListener("click", this.onSubmitButtonHandler.bind(this), { capture: true });
        }

        private onSubmitButtonHandler(e: MouseEvent) {
            e.preventDefault();
            e.stopPropagation();

            let instance = this;

            let $thisBtn = $(e.currentTarget);

            try {
                let form = <HTMLFormElement>$thisBtn.closest('form').get(0);

                if (!App.validateForm(form)) return false;

                $thisBtn.addClass('btn-disabled');

                App.subscribeCatalog(form);

                App.submitForm(form).then(() => {
                    App.showThanks()
                    $thisBtn.removeClass('btn-disabled');

                    instance.onOk();
                })
                .catch(function(error){
                    //var text = error;
                    console.error(error);
                    App.showError()
                    $thisBtn.removeClass('btn-disabled');

                    instance.onCancel();
                });
            } catch (err) {
                let text = err.stack;
                console.error(text);
                App.showError();
                $thisBtn.removeClass('btn-disabled');
                instance.onCancel();
            }

            return false;
        }

        private onOk(){
            this.hide();
            if(this._resolve) {
                this._resolve({ action: "ok", data: null });
            }
        }

        private onCancel(){
            this.hide();
            if(this._resolve) {
                this._resolve({ action: "cancel", data: null });
            }
        }

        protected override onClose(){
            if(this._resolve) {
                this._resolve({ action: "cancel", data: null });
            }
        }

        public override show() : Promise<IPopupResult> {
            let instance = this;
            let popupContentElement = <HTMLElement>document.querySelector(".js-popup_price form");
            let copy = <HTMLElement>popupContentElement.cloneNode(true);
            copy.style.display = "";

            this.setup(copy);

            App.reachGoal(B2B.Retarget.FormOpen);
            this.setContent(copy);
            super.show();

            // @ts-ignore
            $(this.element).find("input[name=phone]").mask('9 (999) 999-99-99');

            return new Promise<IPopupResult>((resolve) => {
                instance._resolve = resolve;
            });
        }
    }
}